import React, { useEffect } from 'react';

const EmployeeBalances = () => {
  React.useEffect(() => {
    // eslint-disable-next-line no-console
    console.warn('Placeholder: EmployeeBalances is not implemented yet.');
  }, []);
  return (
    <>
  { /*EmployeeBalances */} 
 </>
  );
};

export default EmployeeBalances;
